import { render, staticRenderFns } from "./RadioCircle.vue?vue&type=template&id=64562d85&scoped=true"
import script from "./RadioCircle.vue?vue&type=script&lang=js"
export * from "./RadioCircle.vue?vue&type=script&lang=js"
import style0 from "./RadioCircle.vue?vue&type=style&index=0&id=64562d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64562d85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
